module.exports = __webpack_public_path__ + "img/left-int.c07e2645.svg";